//子表函数--23个
export const AnalyticalFunc = [
  {
    "key": "IsNull",
    "name": "是空值",
    "params": [
      {
        "key": "obj",
        "name": "檢測對象",
        "type": "object"
      }
    ],
    "description": `【功能】：判斷檢測對像是否為空值(null)\n【返回值類型】：布爾值(Boolean)\n【示例】：是空值("語義化表達式")【返回值】：False`,
    "type": "Analytical",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "IsNullOrWhiteSpace",
    "name": "是空串",
    "params": [
      {
        "key": "obj",
        "name": "待判斷字符串",
        "type": "object"
      }
    ],
    "description": `【功能】：判斷檢測對像是否為null、空還是僅有空格組成\n【返回值類型】：布爾值(Boolean)\n【示例】：是空串("語義化表達式")【返回值】：False【示例】：是空串(null)【返回值】：True【示例】：是空串(" ")【返回值】：True`,
    "type": "Analytical",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "IsNaN",
    "name": "非數字",
    "params": [
      {
        "key": "obj",
        "name": "檢測對象",
        "type": "object"
      }
    ],
    "description": `【功能】：判斷檢測對像是否可以轉換成數字(Double)\n【返回值類型】：布爾值(Boolean)\n【示例】：非數字("語義化表達式")【返回值】：True【示例】：非數字(12.3)【返回值】：False【示例】：非數字("123")【返回值】：False`,
    "type": "Analytical",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "IsNumber",
    "name": "是數字",
    "params": [
      {
        "key": "obj",
        "name": "檢測對象",
        "type": "object"
      }
    ],
    "description": `【功能】：判斷檢測對像是否可以轉換成數字(Double)\n【返回值類型】：布爾值(Boolean)\n【示例】：是數字("語義化表達式")【返回值】：False【示例】：是數字(12.3)【返回值】：True【示例】：是數字("123")【返回值】：True`,
    "type": "Analytical",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "ExistData",
    "name": "子錶有無數據",
    "params": [
      {
        "key": "propName",
        "name": "子錶",
        "type": "string"
      }
    ],
    "description": `【功能】：判斷子表中有沒有數據。有數據返回true，無數據返回false。 （所有參數用""包起來）\n【propName】子表屬性（鍊式結構）\n【返回值類型】：布爾(Boolean)\n【示例】：子錶有無數據("Order.OrderItems")`,
    "type": "Analytical",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "CountOfChild",
    "name": "子錶數據數量",
    "params": [
      {
        "key": "table",
        "name": "主表.子表",
        "type": "string"
      }
    ],
    "description": `【功能】返回子表数据的数量（参数用""包起来）
    【参数】
        【table】主表.子表（链式结构）
    【返回值】数量（数值类型）
    【示例】
        【场景】提交单据Order，单据包含差旅明细子表trips
        【需求】获取差旅明细子表的数量
        【举例】子錶數據數量("Order.trips")`,
    "type": "Analytical",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "SortChildData",
    "name": "子錶數據排序",
    "params": [
      {
        "key": "setName",
        "name": "子錶",
        "type": "string"
      },
      {
        "key": "propName",
        "name": "排序字段",
        "type": "string"
      },
      {
        "key": "order",
        "name": "排序方式",
        "type": "string"
      }
    ],
    "description": `【功能】對子表數據進行排序（所有參數用""包起來）
    【參數】
      【setName】子表（鍊式結構）
      【propName】排序字段（字段類型應為數字類型）
      【order】排序方式（"ESC"表示正序從小到大，"DESC"表示倒序從大到小）
    【返回值】無
    【示例】
      【場景】提交單據Order，單據包含差旅明細子表trips，子表包含出差費用money字段
      【需求】按照出差費用money字段對子表從小到大排序
      【舉例】子錶數據排序("Order.trips","money","ESC")`,
    "type": "Analytical",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "IncludedInList",
    "name": "是否在列表中",
    "params": [
      {
        "key": "propName",
        "name": "字段",
        "type": "object"
      },
      {
        "key": "list",
        "name": "數據列表",
        "type": "list"
      }
    ],
    "description": `【功能】：判斷字段是否在數據列表中存在。字段在列表中存在返回true，不存在返回false。支持判斷字符和數字類型。 \n【propName】表屬性（鍊式結構）\n【list】數據列表\n【返回值類型】：布爾(Boolean)\n【示例】：是否在列表中(Order.name,["Zs","Ls"])\n【示例】：是否在列表中(Order.quantity,[100,200])`,
    "type": "Analytical",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "CountByProp",
    "name": "子錶列非空數",
    "params": [
      {
        "key": "chainedPropName",
        "name": "實體集合屬性名",
        "type": "string"
      },
      {
        "key": "propertyName",
        "name": "類型屬性名",
        "type": "string"
      }
    ],
    "description": `【功能】：統計子表所有數據某屬性不為null的記錄數（所有參數用""包起來）\n【setName】主表的子表屬性（鍊式結構）\n【propName】子表屬性\n【返回值類型】：數值(Int32);\n【示例】：子錶列非空數("Order.OrderItems","Quantity")`,
    "type": "Analytical",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "SumByProp",
    "name": "子錶字段求和",
    "params": [
      {
        "key": "chainedPropName",
        "name": "實體集合屬性名",
        "type": "string"
      },
      {
        "key": "propertyName",
        "name": "類型屬性名",
        "type": "string"
      }
    ],
    "description": `【功能】：統計子表中所有數據某屬性的和（所有參數用""包起來）\n【setName】主表的子表屬性（鍊式結構）\n【propName】子表屬性\n【返回值類型】：數值(Double)\n【示例】：子錶字段求和("Order.OrderItems","Quantity")"`,
    "type": "Analytical",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "AvgByProp",
    "name": "子錶列平均值",
    "params": [
      {
        "key": "chainedPropName",
        "name": "實體集合屬性名",
        "type": "string"
      },
      {
        "key": "propertyName",
        "name": "類型屬性名",
        "type": "string"
      }
    ],
    "description": `【功能】：統計子表所有數據某數字类型屬性的平均值（所有參數用""包起來）\n【setName】主表的子表屬性（鍊式結構）\n【propName】子表屬性\n【返回值類型】：數值(Double)\n【示例】：子錶列平均值("Order.OrderItems","Quantity")`,
    "type": "Analytical",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "MaxByProp",
    "name": "子錶列最大值",
    "params": [
      {
        "key": "chainedPropName",
        "name": "實體集合屬性名",
        "type": "string"
      },
      {
        "key": "propertyName",
        "name": "類型屬性名",
        "type": "string"
      }
    ],
    "description": `【功能】：返回子表所有數據某數字类型屬性的最大值（所有參數用""包起來）\n【setName】主表的子表屬性（鍊式結構）\n【propName】子表屬性\n【返回值類型】：數值(Double)\n【示例】：子錶列最大值("Order.OrderItems","Quantity")`,
    "type": "Analytical",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "MinByProp",
    "name": "子錶列最小值",
    "params": [
      {
        "key": "chainedPropName",
        "name": "實體集合屬性名",
        "type": "string"
      },
      {
        "key": "propertyName",
        "name": "類型屬性名",
        "type": "string"
      }
    ],
    "description": `【功能】：返回子表所有數據某數字类型屬性的最小值（所有參數用""包起來）\n【setName】主表的子表屬性（鍊式結構）\n【propName】子表屬性\n【返回值類型】：數值(Double)\n【示例】：子錶列最小值("Order.OrderItems","Quantity")`,
    "type": "Analytical",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "IsExistRecord",
    "name": "子錶有無等於匹配值",
    "params": [
      {
        "key": "chainedPropName",
        "name": "鍊式名稱",
        "type": "string"
      },
      {
        "key": "propertyName",
        "name": "屬性名",
        "type": "string"
      },
      {
        "key": "match",
        "name": "匹配值",
        "type": "string"
      }
    ],
    "description": `【功能】：判斷子表所有數據某屬性是否存在等於匹配字符的值（所有參數用""包起來）\n【setName】主表的子表屬性（鍊式結構）\n【propName】子表屬性\n【match】匹配值\n【返回值類型】：布爾值(Boolean)\n【示例】：子錶有無等於匹配值("salesorder.items","code","lc")【返回值】：False/True`,
    "type": "Analytical",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "IsContainMatch",
    "name": "子錶有無包含匹配值",
    "params": [
      {
        "key": "table",
        "name": "主錶.子錶",
        "type": "string"
      },
      {
        "key": "property",
        "name": "子錶字段",
        "type": "string"
      },
      {
        "key": "match",
        "name": "匹配值",
        "type": "string"
      }
    ],
    "description": `【功能】判断子表某字段是否存在包含匹配值的数据（参数用""包起来）
    【参数】
        【table】主表.子表（链式结构）
        【property】子表字段
        【match】匹配值
    【返回值】true或false
    【示例】
        【场景】提交单据Order，单据包含差旅明细子表trips，子表包含出差方式way
        【需求】判断差旅明细子表trips是否存在出差方式way包含匹配值'飞机'的数据
        【举例】子錶有無包含匹配值("Order.trips","way","飞机")`,
    "type": "Analytical",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "ListGreaterThan",
    "name": "子錶有無大於匹配值",
    "params": [
      {
        "key": "chainedPropName",
        "name": "鍊式名稱",
        "type": "string"
      },
      {
        "key": "propertyName",
        "name": "屬性名",
        "type": "string"
      },
      {
        "key": "match",
        "name": "匹配值",
        "type": "double"
      }
    ],
    "description": `【功能】：判斷子表所有數據某數字类型屬性是否存在大於匹配字符的值（前兩個參數用""包起來）\n【setName】主表的子表屬性（鍊式結構）\n【propName】子表屬性\n【match】匹配值\n【返回值類型】：布爾值(Boolean)\n【示例】：子錶有無大於匹配值("salesorder.items","num",100)【返回值】：False/True`,
    "type": "Analytical",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "ListLessThan",
    "name": "子錶有無小於匹配值",
    "params": [
      {
        "key": "chainedPropName",
        "name": "鍊式名稱",
        "type": "string"
      },
      {
        "key": "propertyName",
        "name": "屬性名",
        "type": "string"
      },
      {
        "key": "match",
        "name": "匹配值",
        "type": "double"
      }
    ],
    "description": `【功能】：判斷子表所有數據某數字类型屬性是否存在小於匹配字符的值（前兩個參數用""包起來）\n【setName】主表的子表屬性（鍊式結構）\n【propName】子表屬性\n【match】匹配值\n【返回值類型】：布爾值(Boolean)\n【示例】：子錶有無小於匹配值("salesorder.items","num",100)【返回值】：False/True`,
    "type": "Analytical",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "ListStartWith",
    "name": "子錶有無以匹配值開頭",
    "params": [
      {
        "key": "chainedPropName",
        "name": "鍊式名稱",
        "type": "string"
      },
      {
        "key": "propertyName",
        "name": "屬性名",
        "type": "string"
      },
      {
        "key": "match",
        "name": "匹配值",
        "type": "string"
      }
    ],


    "description": `【功能】：判斷子表所有數據某屬性是否存在開頭是匹配字符的值（所有參數用""包起來）\n【setName】主表的子表屬性（鍊式結構）\n【propName】子表屬性\n【match】匹配值\n【返回值類型】：布爾值(Boolean)\n【示例】：子錶有無以匹配值開頭("salesorder.items","code","lc")【返回值】：False/True`,
    "type": "Analytical",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "ListEndWith",
    "name": "子錶有無以匹配值結尾",
    "params": [
      {
        "key": "chainedPropName",
        "name": "鍊式名稱",
        "type": "string"
      },
      {
        "key": "propertyName",
        "name": "屬性名",
        "type": "string"
      },
      {
        "key": "match",
        "name": "匹配值",
        "type": "string"
      }
    ],
    "description": `【功能】：判斷子表所有數據某屬性是否存在結尾是匹配字符的值（所有參數用""包起來）\n【setName】主表的子表屬性（鍊式結構）\n【propName】子表屬性\n【match】匹配值\n【返回值類型】：布爾值(Boolean)\n【示例】：子錶有無以匹配值結尾("salesorder.items","code","lc")【返回值】：False/True`,
    "type": "Analytical",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "GetComputeJsonData",
    "name": "子錶字段取JSON串",
    "params": [
      {
        "key": "chainedPropName",
        "name": "鍊式名稱",
        "type": "string"
      },
      {
        "key": "propertyName",
        "name": "屬性名",
        "type": "string"
      }
    ],
    "description": `【功能】：獲取子表中所有數據某屬性的值，並以JSON串形式返回（所有參數用""包起來）\n【setName】主表的子表屬性（鍊式結構）\n【propName】子表屬性\n【返回值類型】：對象(String)【返回值示例】：[11,22,33]`,
    "type": "Analytical",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "MultiplyChildNumber",
    "name": "子錶屬性乘積求和",
    "params": [
      {
        "key": "childTable",
        "name": "子錶鍊式名稱",
        "type": "string"
      },
      {
        "key": "prop1",
        "name": "屬性一",
        "type": "string"
      },
      {
        "key": "prop2",
        "name": "屬性二",
        "type": "string"
      }
    ],
    "description": `【功能】對子表的兩個數字類型屬性，先做乘積，然後求和（所有參數用""包起來）
【參數】
  【table】主表中子表屬性（鍊式結構）
  【prop1】屬性一（類型應為數字類型）
  【prop2】屬性二（類型應為數字類型）
【返回值】數字型
【示例】
  【場景】提交單據Order，單據包含差旅明細子表trips，子表包含出差天數days、出差費用money
  【需求】獲取差旅明細的總費用，即子表出差天數x出差費用的總和
  【舉例】子錶屬性乘積求和("Order.trips","days","money")`,
    "type": "Analytical",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "MinValueOfPeriod",
    "name": "時間範圍內取最小值",
    "params": [
      {
        "key": "table",
        "name": "主表.子表",
        "type": "string"
      },
      {
        "key": "timeProp",
        "name": "比较时间字段",
        "type": "string"
      },
      {
        "key": "valueProp",
        "name": "取值字段",
        "type": "string"
      },
      {
        "key": "startTime",
        "name": "起始时间",
        "type": "string"
      },
      {
        "key": "endTime",
        "name": "结束时间",
        "type": "string"
      }
    ],
    "description": `【功能】在指定时间范围内，取子表某字段的最小值（参数用""包起来）
    【参数】
        【table】主表.子表（链式结构）
        【timeProp】比较时间字段（字段类型应为时间类型）
        【valueProp】取值字段（字段类型应为数字类型）
        【startTime】起始时间（支持'yyyy-MM-dd' 或 'yyyy-MM-dd hh:mm:ss'）
        【endTime】结束时间（支持'yyyy-MM-dd' 或 'yyyy-MM-dd hh:mm:ss'）
    【返回值】时间范围内，子表某字段的最小值
    【示例】
        【场景】提交单据Order，单据包含差旅明细子表trips，子表包含出差费用money字段，出差日期date字段
        【需求】获取2022-10-01到2022-10-07时间段内，哪一天的出差费用money最小
        【举例】時間範圍內取最小值("Order.trips","date","money","2022-10-01","2022-10-07")`,
    "type": "Analytical",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "MaxValueOfPeriod",
    "name": "時間範圍內取最大值",
    "params": [
      {
        "key": "table",
        "name": "主表.子表",
        "type": "string"
      },
      {
        "key": "timeProp",
        "name": "比较时间字段",
        "type": "string"
      },
      {
        "key": "valueProp",
        "name": "取值字段",
        "type": "string"
      },
      {
        "key": "startTime",
        "name": "起始时间",
        "type": "string"
      },
      {
        "key": "endTime",
        "name": "结束时间",
        "type": "string"
      }
    ],
    "description": `【功能】在指定时间范围内，取子表某字段的最大值（参数用""包起来）
    【参数】
        【table】主表.子表（链式结构）
        【timeProp】比较时间字段（字段类型应为时间类型）
        【valueProp】取值字段（字段类型应为数字类型）
        【startTime】起始时间（支持'yyyy-MM-dd' 或 'yyyy-MM-dd hh:mm:ss'）
        【endTime】结束时间（支持'yyyy-MM-dd' 或 'yyyy-MM-dd hh:mm:ss'）
    【返回值】时间范围内，子表某字段的最大值
    【示例】
        【场景】提交单据Order，单据包含差旅明细子表trips，子表包含出差费用money字段，出差日期date字段
        【需求】获取2022-10-01到2022-10-07时间段内，哪一天的出差费用money最大
        【举例】時間範圍內取最大值("Order.trips","date","money","2022-10-01","2022-10-07")`,
    "type": "Analytical",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "AvgValueOfPeriod",
    "name": "時間範圍內取平均值",
    "params": [
      {
        "key": "table",
        "name": "主表.子表",
        "type": "string"
      },
      {
        "key": "timeProp",
        "name": "比较时间字段",
        "type": "string"
      },
      {
        "key": "valueProp",
        "name": "取值字段",
        "type": "string"
      },
      {
        "key": "startTime",
        "name": "起始时间",
        "type": "string"
      },
      {
        "key": "endTime",
        "name": "结束时间",
        "type": "string"
      }
    ],
    "description": `【功能】在指定时间范围内，取子表某字段的平均值（所有参数用""包起来）
    【参数】
        【table】主表.子表（链式结构）
        【timeProp】比较时间字段（字段类型应为时间类型）
        【valueProp】取值字段（字段类型应为数字类型）
        【startTime】起始时间（支持'yyyy-MM-dd' 或 'yyyy-MM-dd hh:mm:ss'）
        【endTime】结束时间（支持'yyyy-MM-dd' 或 'yyyy-MM-dd hh:mm:ss'）
    【返回值】时间范围内，子表某字段的平均值
    【示例】
        【场景】提交单据Order，单据包含差旅明细子表trips，子表包含出差费用money字段，出差日期date字段
        【需求】获取2022-10-01到2022-10-07时间段内，平均的出差费用money是多少
        【举例】時間範圍內取平均值("Order.trips","date","money","2022-10-01","2022-10-07")`,
    "type": "Analytical",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "GetSessionValue",
    "name": "獲取會話變量的值",
    "params": [
      {
        "key": "name",
        "name": "會話變量名",
        "type": "string"
      }
    ],
    "description": `【功能】：獲取用戶會話變量的值\n【name】：會話變量名稱\n【返回值類型】：對象(Object)`,
    "type": "Analytical",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "GetContextParameter",
    "name": "獲取上下文變量的值",
    "params": [
      {
        "key": "name",
        "name": "上下文變量名",
        "type": "string"
      }
    ],
    "description": `【功能】：獲取上下文變量的值\n【name】：上下文變量名稱\n【返回值類型】：對象(Object)`,
    "type": "Analytical",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "getComputeJsonData",
    "name": "根據屬性名獲取JSON串"
  },
  {
    "key": "GetInjectedEntity",
    "name": "根據注入名獲取注入對象",
    "params": [
      {
        "key": "name",
        "name": "注入名",
        "type": "string"
      }
    ],
    "description": `【功能】：獲取運行時注入對象的實際對象(參數用""包起來），不支持獲取屬性\n【name】注入对象名稱\n【返回值類型】：對象(Object)`,
    "type": "Analytical",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "GetChainedPropertyValue",
    "name": "根據屬性名獲取屬性值",
    "params": [
      {
        "key": "propName",
        "name": "属性",
        "type": "string"
      }
    ],
    "description": `【功能】：獲取運行時注入屬性的實際值(參數用""包起來）\n【propName】屬性（鍊式結構）\n【返回值類型】：對象(Object)`,
    "type": "Analytical",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "ParseEnum",
    "name": "枚舉取值",
    "params": [
      {
        "key": "name",
        "name": "枚舉欄位",
        "type": "string"
      },
      {
        "key": "map",
        "name": "枚舉集合",
        "type": "obj"
      },
    ],
    "description": `【功能】：將枚舉解析為顯示值【返回值類型】：數位或字串\n【示例】：枚舉取值(SysApproval.version，Enum.SysApproval.version)== '通過'【返回值】："true"`,
    "type": "Special",
    "keyFront": "DefaultFunction",
    "className": ""
  }
]